export const mrpTr = {
  title: 'Malzeme ihtiyaç planlaması',
  subtitle:
    'Yeniden üretilebilir kaynak anlık görüntüsüyle zamana bağlı ihtiyaçlar, girişler ve bağlayıcı olmayan öneriler.',
  help: { open: 'Malzeme ihtiyaç planlaması yardımını aç' },
  tabs: { planning: 'Planlama', history: 'Çalıştırma geçmişi', policies: 'Planlama ilkeleri' },
  run: {
    title: 'MRP çalıştırması oluştur',
    description:
      'Planlama tarihi, dönem ve isteğe bağlı ürün kapsamını seçin. MRP hiçbir zaman otomatik sipariş oluşturmaz.',
  },
  fields: {
    asOf: 'Planlama tarihi',
    horizon: 'Dönem sonu',
    productScope: 'Ürün kapsamı',
    strategy: 'Tedarik stratejisi',
    safetyStock: 'Emniyet stoku',
    procurementLead: 'Tedarik süresi (gün)',
    productionLead: 'Üretim süresi (gün)',
    productionMinimum: 'Asgari üretim miktarı',
    productionLot: 'Üretim parti büyüklüğü',
    note: 'Gerekçe / not',
  },
  allProducts: 'Stok yönetimli tüm ürünler',
  actions: {
    run: 'MRP çalıştır',
    'convert-purchase': 'Satın alma taslağı oluştur',
    'convert-production': 'Üretim taslağı oluştur',
    dismiss: 'Öneriyi reddet',
  },
  messages: {
    invalidInput: 'Planlama bilgilerini kontrol edin.',
    runCreated: 'Değişmez MRP anlık görüntüsü oluşturuldu.',
    policySaved: 'Planlama ilkesi kaydedildi.',
    'convert-purchase': 'Satın alma taslağı açıkça oluşturuldu.',
    'convert-production': 'Üretim taslağı açıkça oluşturuldu.',
    dismiss: 'Öneri gerekçeyle reddedildi.',
  },
  stats: {
    products: 'Ürünler',
    shortages: 'Eksikler',
    purchase: 'Satın alma önerileri',
    production: 'Üretim önerileri',
    manual: 'Manuel inceleme',
    warnings: 'Uyarılar',
  },
  columns: {
    product: 'Ürün',
    gross: 'Brüt ihtiyaç',
    available: 'Kullanılabilir stok',
    reserved: 'Rezerve',
    receipts: 'Beklenen girişler',
    net: 'Net ihtiyaç',
    due: 'İhtiyaç tarihi',
    action: 'Eylem önerisi',
    date: 'Tarih',
    event: 'Olay',
    quantity: 'Miktar',
    formula: 'Hesaplama',
    run: 'Çalıştırma',
    created: 'Oluşturma',
  },
  empty: {
    noRunTitle: 'Planlama sonucu seçilmedi',
    noRun: 'Yeni çalıştırma oluşturun veya geçmişten değişmez bir sonuç seçin.',
  },
  snapshot: 'Kaynak karması {{sourceHash}} · sonuç karması {{resultHash}}',
  details: {
    timeline: 'Hesaplama izi',
    timelineDescription:
      'Aynı gün girişler ihtiyaçlardan önce işlenir; her önerilen giriş hedef tamponu yeniden sağlar.',
    sources: 'İhtiyaç ve tedarik kaynakları',
    sourcesDescription:
      'Her miktar bu çalıştırmada kullanılan belgeye, üretim emrine veya stok anlık görüntüsüne bağlıdır.',
  },
  events: {
    OPENING: 'Başlangıç stoku',
    DEMAND: 'İhtiyaç',
    SUPPLY: 'Giriş',
    PLANNED_RECEIPT: 'Önerilen giriş',
  },
  sourceTypes: {
    SALES_ORDER: 'Müşteri siparişi',
    PRODUCTION_MATERIAL: 'Planlı üretim malzemesi',
    PLANNED_PRODUCTION_EXPLOSION: 'Açılmış reçete ihtiyacı',
    STOCK: 'Uygun stok anlık görüntüsü',
    PURCHASE_ORDER: 'Açık satın alma siparişi',
    PRODUCTION_ORDER: 'Planlı üretim girişi',
  },
  suggestion: { none: 'Eksik yok' },
  statuses: { OPEN: 'Açık', CONVERTED: 'Dönüştürüldü', DISMISSED: 'Reddedildi' },
  strategies: {
    AUTO: 'Otomatik kural',
    BUY: 'Satın al',
    MAKE: 'Üret',
    BUY_OR_MAKE: 'Satın al veya üret',
    NONE: 'Yalnız manuel inceleme',
  },
  policy: {
    title: 'Ürün planlama ilkeleri',
    description: 'Eşikler ürün kartında kalır; strateji, süre ve lot kuralları burada eklenir.',
    dialogTitle: 'Planlama ilkesini düzenle',
    dialogDescription: 'Sürüm kontrolü eş zamanlı üzerine yazmayı önler.',
  },
  decision: {
    'convert-purchase': {
      title: 'Satın alma taslağı oluşturulsun mu?',
      description:
        'Bu açık işlem dondurulmuş öneriden yalnız bir taslak oluşturur; göndermez veya onaylamaz.',
      confirm: 'Satın alma taslağının oluşturulmasını onaylıyorum.',
    },
    'convert-production': {
      title: 'Üretim taslağı oluşturulsun mu?',
      description: 'Bu açık işlem öneride saklanan onaylı reçete ve rotayı kullanır.',
      confirm: 'Üretim emri taslağının oluşturulmasını onaylıyorum.',
    },
    dismiss: {
      title: 'Eylem önerisi reddedilsin mi?',
      description: 'Eksik değişmez çalıştırmada görünür kalır ve gerekçe denetim izine kaydedilir.',
      confirm: 'Bu önerinin reddedilmesini onaylıyorum.',
    },
  },
  warningTitle: 'Planlama uyarısı',
  warnings: {
    MRP_BATCH_STOCK_RECONCILIATION: 'Uygun parti toplamı ürün stok bakiyesinden farklı.',
    MRP_BATCH_SHELF_LIFE_MISSING: 'Gerekli raf ömrü bilgisi olmayan en az bir parti dışlandı.',
    MRP_INCOMPATIBLE_UNIT: 'Uyumsuz birimli bir kaynak miktarı dışlandı.',
    MRP_SUPPLIER_MISSING: 'Aktif ve onaylı tedarikçi eşlemesi yok.',
    MRP_APPROVED_RECIPE_OR_ROUTING_MISSING: 'Uygun onaylı reçete ve süreç rotası yok.',
    MRP_PROCUREMENT_DISABLED: 'Bu ürün için otomatik tedarik kapalı.',
    MRP_RELEASE_DATE_OVERDUE:
      'Hesaplanan başlatma tarihi planlama tarihinden önce; hemen inceleme gerekir.',
  },
} as const;
